import { Component, OnInit } from '@angular/core';
import { GridOptions, GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { printMessage } from 'src/app/constants/service.constants';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { RequestTypeModalComponent } from '../grants-applications/request-type-modal/request-type-modal.component';
import { DateObject, GM_APP, ModuleMenu } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { HeadService } from 'src/app/services/common/headservice';
import { UserService } from 'src/app/services/user.service';
import { DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { IstDataShareService } from '../../services/ist/ist-datashare.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionLike } from 'rxjs';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { UserInstructionModalComponent } from '../grants-applications/user-instruction-modal/user-instruction-modal.component';
import { SelectApplicationtypeModelComponent } from 'src/app/common/operations-bar/select-applicationtype-model/select-applicationtype-model.component';
import { ColumnsSelectionPopupComponent, UserPreferenceColumns, UserPreferenceColumnsList } from 'src/app/common/columns-selection-popup/columns-selection-popup.component';

@Component({
  selector: 'app-grants-my-applications',
  templateUrl: './grants-my-applications.component.html',
  styleUrls: ['./grants-my-applications.component.scss']
})
export class GrantsMyApplicationsComponent implements OnInit {
  collapesedOrNot: boolean;
  gridApi: GridApi;
  columnDefs;
  operations;
  alloperations;
  rowData;
  advanceSearch;
  selectedRow;
  caseDetails;
  grantsapp: GM_APP;
  grants: GM_APP[];
  userType: string = "";
  menudata: ModuleMenu;
  screentoopen: string;
  grantsForm: UntypedFormGroup;
  TheraputicAreaList: any;
  ApplicationTypeList: any[]; 
  StatusList; any;
  GrantTypeList: any;
  GrandTypeList: Array<any> = [];
  IsOnlyGrandType: boolean = false;
  subGetData: SubscriptionLike;
  orgDetails: any;
  Grants_Display_Name: any;
  columns:any;
  istAlluserPreferenceColumns: UserPreferenceColumns = { ModuleID: '2', IsAllApplications: true, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  istMyuserPreferenceColumns: UserPreferenceColumns = { ModuleID: '2', IsAllApplications: false, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  grantsAlluserPreferenceColumns: UserPreferenceColumns = { ModuleID: '4', IsAllApplications: true, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  grantsMyuserPreferenceColumns: UserPreferenceColumns = { ModuleID: '4', IsAllApplications: false, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  eapAlluserPreferenceColumns: UserPreferenceColumns = { ModuleID: '5', IsAllApplications: true, THERAPEUTIC_AREA_ID: false, STUDY_TYPE: false, PRODUCTIDS: false, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  eapMyuserPreferenceColumns: UserPreferenceColumns = { ModuleID: '5', IsAllApplications: false, THERAPEUTIC_AREA_ID: false, STUDY_TYPE: false, PRODUCTIDS: false, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  userPreferenceColumnsLst: UserPreferenceColumnsList = { IstAllApplications: this.istAlluserPreferenceColumns, IstMyApplications: this.istMyuserPreferenceColumns, GrantsAllApplications: this.grantsAlluserPreferenceColumns, GrantsMyApplications: this.grantsMyuserPreferenceColumns,EapAllApplications: this.eapAlluserPreferenceColumns, EapMyApplications: this.eapMyuserPreferenceColumns };
  ApplicationID:string = '';
  ApplicationType:string = '';
  GrantType:string = '';
  PhysicianName:string = 'Physician Name';
  TherapeuticArea:string = 'Therapeutic area';
  RequestType:string = '';
  Product:string = '';
  StudyType:string = '';
  Owner:string = '';
  Status:string = '';
  maxDate = new Date() ; 
  Submit_from_date : DateObject;
  Submit_end_date : DateObject;
  isHadPermission: boolean = false;
  
  constructor(
    private router: Router,
    public routerr: ActivatedRoute,
    private summaryService: GrantsSummaryService,
    private commonService: CommonService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private header: HeadService,
    private dataShare: GrantsDatashareService,
    private userService: UserService,
    public apiService: ApidataRequestService,
    private grantsDataShare: GrantsDatashareService
  ) {

  }

  ngOnInit() {
    this.columns = this.routerr.snapshot.data["items"][0];
    if(this.routerr.snapshot.data["items"][1] != null){
      this.userPreferenceColumnsLst = this.routerr.snapshot.data["items"][1];
    } 
    //this.StatusList= [{ "value": "", "label": "All" },{ "value": "1", "label": "Draft" }, { "value": "2", "label": "Submitted" }, { "value": "3", "label": "Review Ongoing" }, { "value": "4", "label": "Accepted" }, { "value": "5", "label": "Closed" }, { "value": "6", "label": "Rejected" }, { "value": "7", "label": "On-hold" }, { "value": "8", "label": "Withdrawn" }, { "value": "9", "label": "Discarded" }];
    this.collapesedOrNot = false;
    this.userType = this.userService.getUserType();
    this.setDefaultData();
    this.orgDetails = this.commonService.getOrgDetails();
    this.Grants_Display_Name = this.orgDetails[0].GRANTS_DISPLAY_NAME;

    this.grantsForm = new UntypedFormGroup({
      APPLICATIONID: new UntypedFormControl(""),
      GRANT_TYPE: new UntypedFormControl(""),
      ApplicationType: new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      THERAPEUTICAREA: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(""),
      DATEFROM: new UntypedFormControl(""),
      DATETO: new UntypedFormControl(""),
      TYPE: new UntypedFormControl("M")
    });

    if (this.userType == 'I') {
      let hadeditPermission = this.commonService.getScreenPermission("402", "E");
      if (hadeditPermission) {
        this.isHadPermission = true;
      }
    }
    else if (this.userType == 'E') {
      this.isHadPermission = true;
    };

    var formData = this.grantsForm.value;
    this.setSearchSummary(formData);
    this.GetMasterData();
    this.getApplicationsTypes();
  }

  setSearchSummary(formData) {

    if(formData["DATEFROM"] != null && formData["DATEFROM"] != undefined && formData["DATEFROM"] != 'Invalid Date') 
    {
      formData["DATEFROMOBJ"] = this.Submit_from_date; 
    }
    if(formData["DATETO"] != null && formData["DATETO"] != undefined && formData["DATETO"] != 'Invalid Date') {
      formData["DATETOOBJ"] = this.Submit_end_date;
    }

    this.summaryService.getGrantAppAdvSearch("api/gmapp/getadvsearch", formData).subscribe(data => {
      this.grants = data;
    });
  }

  submitfromDate(event){
    this.grantsForm.get('DATETO')?.setValue(null);
    this.Submit_from_date = {
      Day : event.getDate(),
      Month : event.getMonth()+1,
      Year : event.getFullYear(),
      Hours : 0,
      Minutes : 0,
      Seconds : 0,
      HasValue : true
    };
  }
  
  submitendDate(event){
    this.Submit_end_date = {
      Day : event.getDate(),
      Month : event.getMonth()+1,
      Year : event.getFullYear(),
      Hours : 23,
      Minutes : 59,
      Seconds : 59,
      HasValue : true
    }
  }

  setDefaultData() {



    if (this.userType === "E") {
      this.advanceSearch = {
        "fields": [
          {
            "label": "Application ID",
            "field": "simple",
            "type": "text"
          },
          {
            "label": "Grant Type",
            "field": "Grant_type",
            "type": "dropdown"
          },
          {
            "label": "Therapeutic Area",
            "field": "TherapeuticArea",
            "type": "dropdown",
            "options": this.TheraputicAreaList,
          },
          {
            "label": "Status",
            "field": "status",
            "type": "dropdown"
          },
          {
            "label": "Submitted From Date",
            "field": "DATEFROM",
            "type": "date"
          },
          {
            "label": "Submitted To Date",
            "field": "DATETO",
            "type": "date"
          }
        ],
        "filters": []
      }
      this.setUserPreferenceColumns();
      this.alloperations = [
        {
          "name": "New Application",
          "id": "add"
        }
      ]
      this.caseDetails = [
        {
          "caseSet": {
            "caseHeading": "",
            "caseData": [
              {
                "label": "Application ID",
                "value": "APPLICATION_CODE"
              },
              {
                "label": "Grant Type",
                "value": "GRANTTYPE"
              },
              {
                "label": "TherapeuticArea",
                "value": "TherapeuticArea"
              },
              {
                "label": "Submitted On",
                "value": "SubmittedOnStr"
              },
              // {
              //   "label": "Owner",
              //   "value": "AssignedStr"
              // },
              {
                "label": "Last Updated On",
                "value": "UpdateDateStr"
              },
              {
                "label": "Status",
                "value": "StatuStr"
              },
              {
                "label": "Organization Name ",
                "value": "OrgName"
              },
              {
                "label": "Tax Status",
                "value": "TaxStatus"
              },
              {
                "label": "Tax ID",
                "value": "TaxID"
              },
              {
                "label": "Budget Requested",
                "value": "REQUESTED_AMOUNT"
              },
              {
                "label": "Budget Allocated",
                "value": "ALLOCATION_AMOUNT"
              },
              {
                "label": "Reconciliation Amount",
                "value": "EXPENDITURE_AMOUNT"
              }
            ]

          }
        }];
    }
    else if (this.userType === "I") {
      this.advanceSearch = {
        "fields": [
          {
            "label": "Application ID",
            "field": "ApplicationID",
            "type": "text"
          },
          {
            "label": "Grant Type",
            "field": "Grant_type",
            "type": "dropdown"
          },
          {
            "label": "Physician Name",
            "field": "PhysicianName",
            "type": "text"
          },
          {
            "label": "Therapeutic Area",
            "field": "TherapeuticArea",
            "type": "dropdown",
            "options": this.TheraputicAreaList,
          },
          {
            "label": "Status",
            "field": "status",
            "type": "dropdown"
          },
          {
            "label": "Submitted From Date",
            "field": "DATEFROM",
            "type": "date"
          },
          {
            "label": "Submitted To Date",
            "field": "DATETO",
            "type": "date"
          }
        ],
        "filters": []
      }
      this.setUserPreferenceColumns();
      this.alloperations = [];

      this.caseDetails = [
        {
          "caseSet": {
            "caseHeading": "",
            "caseData": [
              {
                "label": "Organization Name ",
                "value": "OrgName"
              },
              {
                "label": "Tax Status",
                "value": "TaxStatus"
              },
              {
                "label": "Tax ID",
                "value": "TaxID"
              },
              {
                "label": "Application ID",
                "value": "APPLICATION_CODE"
              },
              {
                "label": "Full Name",
                "value": "FullName"
              },
              {
                "label": "Email ID",
                "value": "EMail"
              },
              {
                "label": "Grant Type",
                "value": "GRANTTYPE"
              },
              {
                "label": "TherapeuticArea",
                "value": "TherapeuticArea"
              },
              {
                "label": "Submitted On",
                "value": "SubmittedOnStr"
              },
              {
                "label": "Last Updated On",
                "value": "UpdateDateStr"
              },
              {
                "label": "Status",
                "value": "StatuStr"
              },
              {
                "label": "Requested Budget",
                "value": "REQUESTED_AMOUNT"
              },
              {
                "label": "Approved Budget",
                "value": "ALLOCATION_AMOUNT"
              },
              {
                "label": "Reconciliation Amount",
                "value": "EXPENDITURE_AMOUNT"
              },
              {
                "label": "Authorized Signer",
                "value": "AUTH_SIGNER"
              }
            ]
          }
        }];
    }
    this.operations = this.alloperations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
   
     switch(event.operationType){
      case 'edit':
       this.commonService.refreshApplicationPage(event.data["APPLICATION_ID"],"grants","","my");
        break;
      case 'rfi':
        this.commonService.LaunchingRequiredScreen(event.data["APPLICATION_ID"],"grants","rfi_request");
        break;
      case 'mail':
        this.commonService.LaunchingRequiredScreen(event.data["APPLICATION_ID"],"grants","correspondence_request");
        break;
    }
  }

  

  print() {
    this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
      data: {
        operation: { hasOpr: false },
        heading: 'Print Application',
        content: { heading: '', description: printMessage }
      }
    });
  }

  add() {
    this['self'].summaryService.getData("api/common/GetOrgGrantTypes").subscribe(
      (res) => {
        if (res["Status"]) {
          let submodules = [];
          let modulecode = "";
          let IsCHARITY = res["Data"].CHARITY;
          let IsSPONSERSHIP = res["Data"].SPONSERSHIP;
          let IsCME = res["Data"].CME;
          if (IsCHARITY) {
            submodules.push(3);
            modulecode = "GRANTSCHARITABLE";
          }
          if (IsSPONSERSHIP) {
            submodules.push(2);
            modulecode = "GRANTSSPONSORSHIP";
          }
          if (IsCME) {
            submodules.push(1);
            modulecode = "GRANTSCME";
          }
          if (submodules.length > 1) {
            let modalRef1 = this['self'].modalService.open(RequestTypeModalComponent, {
              backdrop: false,
              keyboard: false,
              windowClass: 'modal-lg right modal-right',
              animation: true
            });
          }
          else {
            if (submodules.length > 0) {
              this['self'].OpenApplication(modulecode,submodules[0]);
            }
          }
        }
      }
    );

   }
  // openGrantsUserInstructions(submodule: any,type:any) {debugger;

  //   const modalRef1 = this.modalService.open(SelectApplicationtypeModelComponent, { backdrop: false, windowClass: 'modal-md pt-5' });
  //   modalRef1.componentInstance.Content = {
  //     heading: 'Select Application Type',
  //     custommessage: '',
  //     Proceed: "Proceed",
  //     Cancel: "Cancel",
  //     ModuleID: "4",
  //     SubModuleID: submodule
  //   }
  //   modalRef1.result.then(result => {
  //    this.summaryService.getInstruction(result).subscribe(summary => {
  //     this.OpenApplication(summary, type);

  //   });
  //   });
  //   // let instructionid = "6"
  //   // if (type === 1)
  //   //   instructionid = "6";
  //   // else if (type === 2)
  //   //   instructionid = "10";
  //   // else if (type === 3)
  //   //   instructionid = "8";
  //   // this.summaryService.getInstruction(instructionid).subscribe(summary => {
  //   //   this.OpenApplication(summary, type);

  //   // });
  // }
   
  OpenApplication(submodule:any,type: any) {
  
    const modalRef = this.modalService.open(SelectApplicationtypeModelComponent, { backdrop: false, windowClass: 'modal-md pt-5' });
    modalRef.componentInstance.Content = {
      heading: 'Select Application Type',
      custommessage: '',
      Proceed: "Proceed",
      Cancel: "Cancel",
      ModuleID: "4",
      SubModuleID: submodule
    }
    modalRef.result.then(result => {
      this.summaryService.getInstruction(result).subscribe(summary => {
        let instruction = summary;
        let Instruction_Status = false;
   
        if (instruction != null) {
          Instruction_Status = instruction.isINSTRUCTIONS_ID;
        }
        if (Instruction_Status) {
          const modalRef1 = this.modalService.open(UserInstructionModalComponent, {
            backdrop: false,
            keyboard: false,
            windowClass: 'modal-lg right modal-right',
            animation: true
          });
          modalRef1.componentInstance.Content = {
            heading: 'Add',
            content: null,
            id: "",
            rtype: type,
            ApplicationType: result
          }
        }
        else {
          this.commonService.refreshApplicationPage("", "grants",result);
        }
  
      });
     

    });
  }
  edit() {
    this['self'].router.navigateByUrl('/home/grants/my-applications/application-ext/:' + this['self'].selectedRow['id'] + '/general_information')
  }


  

  setSearch() {
    this.SearchClear();
    this.setSearchSummary(this.grantsForm.value);
  }

  //// Advace search Functions
  SearchClear() {
    this.grantsForm = new UntypedFormGroup({
      APPLICATIONID: new UntypedFormControl(""),
      GRANT_TYPE: new UntypedFormControl(""),
      ApplicationType : new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      THERAPEUTICAREA: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(""),
      DATEFROM: new UntypedFormControl(""),
      DATETO: new UntypedFormControl(""),
      TYPE: new UntypedFormControl("M")
    });
  }

  AdvanceSearch() {
    this.setSearchSummary(this.grantsForm.value);
  }

  GetTherapeuticAreas() {
    this.summaryService.getData("api/gmapp/gettherapeuticarealist").subscribe((result) => {
      if (result != null) {
        this.TheraputicAreaList = result;
        this.TheraputicAreaList = [{ label: "Select", value: "-1", checked: true }].concat(this.TheraputicAreaList);

      }
    });
  }

  getApplicationsTypes(){
    let moduleID = '4';
    let subModuleID = '-1';
    this.commonService.getAllApplicationTypesforSearch(moduleID, subModuleID).subscribe((result)=>
    {
      if(result)
      {
        this.ApplicationTypeList = result;
      }
    });
  }

  GetStatusList() {
    this.summaryService.getData("api/gmapp/getstatus/4").subscribe(result => {
      if (result != null) {
        this.StatusList = result;
        this.StatusList = [{ label: "Select", value: "-1", checked: true },{ label: "Returned", value: "Returned", checked: true }].concat(this.StatusList);

      }
    });
  }

  GetOrgGrantTypes() {
    this.GrantTypeList = [];
    this.subGetData = this.summaryService.getData("api/common/GetOrgGrantTypesForSearch").subscribe(
      (res) => {

        this.GrantTypeList = res["Data"];

      }
    );
  }
  GetMasterData() {
    this.GetTherapeuticAreas();
    this.GetOrgGrantTypes();
    this.GetStatusList();
  }

  getColumns(){
    this.commonService.GetColumns('4',false).subscribe({
      next:(res)=>{
        if(res){
          this.columns= res;
        }
      }
    }
    )
  }

  setUserPreferenceColumns(){
    this.columnDefs = [];
    this.columns.forEach(x=>{
      if(x.FieldCode == 'APPLICATION_ID'){
        this.ApplicationID = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "APPLICATION_CODE"
          }
        );
      }
      if(x.FieldCode == 'APPLICATION_TYPE'){
        this.ApplicationType = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName":  x.ColumnName,
            "field": "APPLICATION_TYPE_NAME"
          },
        );
      }
      if(x.FieldCode == 'PHYSICIAN_NAME'){
        this.PhysicianName = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "PhysicianName"
          }
        );
      }
      if(x.FieldCode == 'REQUEST_TYPE'){
        this.RequestType = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "REQUEST_TYPE_NAME"
          }
        );
      }
      if(x.FieldCode == 'GRANT_TYPE'){
        this.GrantType = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "GRANTTYPE"
          }
        );
      }
      if(x.FieldCode == 'RAISED_BY' && this.userType == 'I'){
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "CreatedStr"
          }
        );
      }
      // if(x.FieldCode == 'OWNER'){
      //   this.columnDefs.push(
      //     {
      //       "headerName": x.ColumnName,
      //       "field": "AssignedTo"
      //     }
      //   );
      // }
      if(x.FieldCode == 'STATUS'){
        this.Status = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "StatuStr"
          }
        );
      }
      if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.GrantsMyApplications) {
        if (x.FieldCode == 'THERAPEUTIC_AREA_ID') {
          this.TherapeuticArea = x.ColumnName;
          if (this.userPreferenceColumnsLst.GrantsMyApplications.THERAPEUTIC_AREA_ID) {
            this.columnDefs.push(
              {
                "headerName": x.ColumnName,
                "field": "THERAPEUTIC_AREA_NAME"
              }
            );
          }
        }
      }
      if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.GrantsMyApplications) {
        if (this.userPreferenceColumnsLst.GrantsMyApplications.PRODUCTIDS && x.FieldCode == 'PRODUCTIDS') {
          this.columnDefs.push(
            {
              "headerName": x.ColumnName,
              "field": "PRODUCT_NAME"
            },
          );
        }
      }
      if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.GrantsMyApplications) {
        if (this.userPreferenceColumnsLst.GrantsMyApplications.STUDY_TYPE && x.FieldCode == 'STUDY_TYPE') {
          this.columnDefs.push(
            {
              "headerName": x.ColumnName,
              "field": "StudyType"
            },
          );
        }
      }
      if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.GrantsMyApplications) {
        if (this.userPreferenceColumnsLst.GrantsMyApplications.SUBMITTED_ON && x.FieldCode == 'SUBMITTED_ON') {
          this.columnDefs.push(
            {
              "headerName": x.ColumnName,
              "field": "SubmittedOnStr"
            },
          );
        }
      }
      if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.GrantsMyApplications) {
        if (this.userPreferenceColumnsLst.GrantsMyApplications.LAST_UPDATED_ON && x.FieldCode == 'LAST_UPDATED_ON') {
          this.columnDefs.push(
            {
              "headerName": x.ColumnName,
              "field": "UpdateDateStr"
            }
          );
        }
      }
    })
    setTimeout(()=>{
      this.gridApi.refreshHeader();
      this.gridApi.sizeColumnsToFit();
      },500);
  }

  getUserPreferenceColumns(){
    this.commonService.GetUserPreferencesColumns().subscribe({
      next:res=>{
        if(res){
          this.userPreferenceColumnsLst = res;
        }
        this.setUserPreferenceColumns();
      }
    })
  }

  selectColumns($event){
    let modalRef = this.modalService.open(ColumnsSelectionPopupComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md modal-dialog-center',
      animation: true
    });
    modalRef.componentInstance.Content = { columns: this.columns,moduleId:"4",isAllApplications: false};
    modalRef.result.then((result) => {
      this.getUserPreferenceColumns();
    });
  }
}
